/*
 * @Author: lijing
 * @Date: 2022-08-25 10:40:08
 * @Last Modified by: lijing
 * @Last Modified time: 2022-08-26 17:20:43
 */
import React, { FC } from "react";
import { LiveList } from "./components/liveList";

const LiveConfiguration = () => {
  return (
    <div className="coursemanage">
      <LiveList />
    </div>
  );
};

export default LiveConfiguration;
